import React, { useEffect, useState, useRef } from "react";
import { useMediaQuery } from "@mui/material";

import Divider from "@mui/material/Divider";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { Typography, Container, Paper, Box } from "@mui/material";
import { ProjectInfo } from "./ProjectInfo";
import { ProjectDescription } from "./ProjectDescription";
import { ProjectFileUpload } from "./ProjectFileUpload";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

const FormWizard = (props) => {
    const steps = [
        {
            id: "1",
            name: "Project Info",
            subheader: (
                <>
                    Time to get those blank walls filled with beautiful artwork, but first, we need{" "}
                    <span
                        style={{
                            color: "#0080ff",
                        }}>
                        some important information about you.
                    </span>
                </>
            ),
        },
        {
            id: "2",
            name: "File Uploads",
            subheader: (
                <>
                    Having floor plans of your space helps us give you better guidance on{" "}
                    <span
                        style={{
                            color: "#0080ff",
                        }}>
                        sizing, selection, and navigating the building
                    </span>{" "}
                    during installation.
                </>
            ),
        },
        {
            id: "3",
            name: "Description",
            subheader: (
                <>
                    This is your chance to{" "}
                    <span
                        style={{
                            color: "#0080ff",
                        }}>
                        share your thoughts with us
                    </span>{" "}
                    and relay any important information that we haven't already captured.
                </>
            ),
        },
    ];
    const { header, saving } = props;
    const [activeStep, setActiveStep] = React.useState(0);
    const navigate = useNavigate();
    const formRef = useRef();
    const projectInfoRef = useRef();
    const fileUploadRef = useRef();
    const descRef = useRef();
    const [formData, setFormData] = useState(props.formData ? props.formData : {});

    let stepsRef = [projectInfoRef, fileUploadRef, descRef];

    useEffect(() => {
        console.log("formData :: ", formData);
    }, []);

    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
        }
    };

    const handleChange = (value) => {
        console.log("Value:: ", value);
        let newFormValues = { ...formData, ...value };

        setFormData(newFormValues);
    };

    const handleNext = () => {
        // console.log("NEXT :: ",formData," "+stepsRef[activeStep].current.validate());
        if (activeStep < steps?.length - 1) {
            if (stepsRef[activeStep].current.validate()) {
                setActiveStep(activeStep + 1);
            }
        } else {
            props.onSubmit(formData);
        }
    };

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return <ProjectInfo ref={projectInfoRef} onChange={handleChange} formData={formData} />;
            case 1:
                return <ProjectFileUpload ref={fileUploadRef} onChange={handleChange} formData={formData} />;
            case 2:
                return <ProjectDescription ref={projectInfoRef} onChange={handleChange} formData={formData} />;
            default:
                throw new Error("Unknown step");
        }
    };

    return (
        <>
            <Box
                sx={{
                    textAlign: "center",
                    mt: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                <Typography component="div" variant="h3" gutterBottom sx={{ textAlign: "center", fontSize: "1.7rem" }}>
                    {header}
                </Typography>

                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{
                        maxWidth: "42ch",
                        mt: 2,
                        lineHeight: "inherit",
                        fontWeight: "400",
                    }}>
                    {steps[activeStep]?.subheader}
                </Typography>
            </Box>
            <Paper variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                <Box sx={{ my: { xs: 1, md: 1 }, p: { xs: 2, md: 1 } }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps?.map((item) => (
                            <Step key={item?.name}>
                                <StepLabel>
                                    <Typography variant="subtitle1" component="div">
                                        {item?.name}
                                    </Typography>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                <Divider variant="fullwidth" sx={{ p: 0, m: 0 }} />
                {activeStep === steps.length ? (
                    <></>
                ) : (
                    <Box
                        sx={{
                            pl: { xs: 2, md: 2 },
                            pr: { xs: 2, md: 2 },
                            pb: { xs: 2, md: 2 },
                        }}>
                        {getStepContent(activeStep)}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            {activeStep !== 0 ? (
                                <Button variant="outlined" onClick={handleBack} sx={{ mt: 3 }}>
                                    Go back
                                </Button>
                            ) : (
                                <Box></Box>
                            )}
                            <LoadingButton
                                loading={saving}
                                variant="contained"
                                color={activeStep === steps.length - 1 ? "success" : "primary"}
                                onClick={handleNext}
                                sx={{ mt: 3, ml: 1 }}>
                                {activeStep === steps.length - 1 ? "Submit and finish" : "Save and continue"}
                            </LoadingButton>
                        </Box>
                    </Box>
                )}
            </Paper>
        </>
    );
};

export { FormWizard };
